import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ElementOverflowListenerModule } from '®shared/element-overflow-listener';

import { QuickFilterLabelModule } from './quick-filter-label';
import { QuickFiltersMenuComponent } from './quick-filters-menu.component';
import { QuickFiltersService } from './quick-filters.service';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
    ElementOverflowListenerModule,
    QuickFilterLabelModule,
    TooltipModule,
  ],
  declarations: [QuickFiltersMenuComponent],
  providers: [QuickFiltersService],
  exports: [QuickFiltersMenuComponent],
})
export class QuickFiltersMenuModule {}
